import { MediaQuery } from 'models/MediaQueryService';
import { HeaderState } from 'models/HeaderState';
import { useSelector } from 'react-redux';

type ResponsiveState = Pick<HeaderState, 'currentBreakpoint'>;
type MediaFunc = (state: ResponsiveState) => boolean;

const mqCheck =
  (mq: number): MediaFunc =>
  ({ currentBreakpoint }) =>
    currentBreakpoint === mq;
const mqRange =
  (min: number, max: number): MediaFunc =>
  ({ currentBreakpoint }: ResponsiveState) =>
    min <= currentBreakpoint && currentBreakpoint <= max;
export const isLayout =
  (...checks: MediaFunc[]) =>
  (state: ResponsiveState) =>
    checks.some(c => c(state));
export const isMedia = (state: ResponsiveState, min: number, max: number) =>
  mqRange(min, max)(state);
export const isMobile = mqCheck(MediaQuery.Phone);
export const isTablet = mqCheck(MediaQuery.Tablet);
export const isLarge = mqCheck(MediaQuery.Large);
export const isDesktop = mqCheck(MediaQuery.Desktop);
export const isHuge = mqRange(MediaQuery.Huge, MediaQuery.Ultra);
export const isMobileLayout = isLayout(isMobile, isTablet);
export const isTabletLayout = isLayout(isTablet, isLarge);
export const isDesktopLayout = isLayout(isLarge, isDesktop, isHuge);

export const getCurrentBreakpoint = (state: ResponsiveState) => state.currentBreakpoint || 0;

const mq = (mqCheck: MediaFunc) => (): boolean => {
  const currentBreakpoint = useSelector(getCurrentBreakpoint);
  return mqCheck({ currentBreakpoint });
};

export const useMobile = mq(isMobile);
export const useTablet = mq(isTablet);
export const useLarge = mq(isLarge);
export const useDesktop = mq(isDesktop);
